/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Drag_LabelInputs */

const en_audio_recorder_drag_label = /** @type {(inputs: Audio_Recorder_Drag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag to reposition modal`)
};

const fr_audio_recorder_drag_label = /** @type {(inputs: Audio_Recorder_Drag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glisser pour repositionner la boîte de dialogue`)
};

const de_audio_recorder_drag_label = /** @type {(inputs: Audio_Recorder_Drag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Neupositionieren des Modals ziehen.`)
};

const it_audio_recorder_drag_label = /** @type {(inputs: Audio_Recorder_Drag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascina per riposizionare la finestra modale`)
};

const ru_audio_recorder_drag_label = /** @type {(inputs: Audio_Recorder_Drag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перетащите для изменения положения модального окна.`)
};

const es_audio_recorder_drag_label = /** @type {(inputs: Audio_Recorder_Drag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastre para reposicionar el modal`)
};

const zh_cn2_audio_recorder_drag_label = /** @type {(inputs: Audio_Recorder_Drag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拖动以重新定位模态框`)
};

const ja_audio_recorder_drag_label = /** @type {(inputs: Audio_Recorder_Drag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドラッグしてモーダルの位置を変更します`)
};

const hi_audio_recorder_drag_label = /** @type {(inputs: Audio_Recorder_Drag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मोडल को स्थानांतरित करने के लिए खींचें`)
};

const pt_pt2_audio_recorder_drag_label = /** @type {(inputs: Audio_Recorder_Drag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arraste para reposicionar o modal.`)
};

/**
* | output |
* | --- |
* | "Drag to reposition modal" |
*
* @param {Audio_Recorder_Drag_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_drag_label = /** @type {((inputs?: Audio_Recorder_Drag_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Drag_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_drag_label(inputs)
	if (locale === "de") return de_audio_recorder_drag_label(inputs)
	if (locale === "it") return it_audio_recorder_drag_label(inputs)
	if (locale === "ru") return ru_audio_recorder_drag_label(inputs)
	if (locale === "es") return es_audio_recorder_drag_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_drag_label(inputs)
	if (locale === "ja") return ja_audio_recorder_drag_label(inputs)
	if (locale === "hi") return hi_audio_recorder_drag_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_drag_label(inputs)
	return en_audio_recorder_drag_label(inputs)
});